import React from 'react';

import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import GalleryTagsDataTable from './components/GalleryTagsDataTable';
import { galleryTagsLink, galleryTagsSearchParams } from './navigation';
import screenReducer from './screenReducer';

const permission = 46;
const id = 40;

const GalleryTags = withScreen({
  name: 'creatives-gallery-tags',
  searchParams: galleryTagsSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <GalleryTagsDataTable />
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Gallery Internal Tags',
  link: galleryTagsLink,
  screen: <GalleryTags />,
  id: id,
  permission: permission,
});
